export function formatCategoryLimit(
  value: number | undefined | null,
  type: "gig" | "time"
): string {
  if (value === 0 || value == null) {
    return "نامحدود";
  }
  return type === "gig" ? `${value} GB` : `${value} ماه`;
}

export const CATEGORY_LIMIT_HINT =
  "مقدار ۰ به معنی نامحدود است. در صورت خالی گذاشتن، محدودیت اعمال نمی‌شود.";
